$_vikon(document).ready(() => {
    const $paidEduShow = $('#paid-edu-show');
    if ($paidEduShow.length) {
        $_vikon('#paid-edu-show').on('click', function () {
            dlg_ini($_vikon(this).next('div').html());
        });
    }
});

function dlg_ini(content) {
    $_vikon('.vikon-wrapper').append(`${'<div class="modal fade dlg " tabindex="-1" role="dialog" aria-labelledby="myModalLabel" '
        + 'aria-hidden="true"><div class="modal-dialog modal-lg"><div class="modal-content">'
        + '<div class="modal-header"><h4>Об оказании платных образовательных услуг</h4></div>'
        + '<div class="modal-body scroll-bar-auto">'}${content}</div><div class="modal-footer">`
        + '<button type="button" class="btn btn-default" data-dismiss="modal">Закрыть</button>'
        + '</div></div></div></div>');
    show_modal('.dlg');
}

function show_modal(class_name) {
    $_vikon(class_name).modal('show')
        .on('hidden.bs.modal', function () {
            $_vikon(this).remove();
        })
        .on('hide.bs.modal', function () {
            $_vikon(this).remove();
        });
}
